module.exports = __webpack_public_path__ + "static/media/rope-app.a3836a62.svg";